export const ACCOUNT_MENU_ID = 'account-menu'

export enum LabelItems {
	MyAccount = 'header.myAccount.account.link',
	MyPurchases = 'header.myAccount.myPurchases.link',
	Loyalty = 'header.myAccount.loyalty.link',
	LoyaltyMsc = 'header.myAccount.club.link',
	Help = 'header.myAccount.help.link',
	Logout = 'header.myAccount.logout.link',
}
